export default __webpack_public_path__ + "static/media/SeloAbracam.55e4182d.png";